<mat-toolbar class="footer">
  <mat-toolbar-row>
    <span class="mat-spacer"></span>
    <span class="footer-text">Copyright &copy; 2020 - by PRAMA</span>
    <span class="footer-text">&nbsp; v{{appVersion}}</span>
  </mat-toolbar-row>
</mat-toolbar>